var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNutritionalGuidance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7304 2.00003C15.7304 1.25033 15.1226 0.642578 14.3729 0.642578C13.6232 0.642578 13.0155 1.25033 13.0155 2.00003V4.71488V10.1447V12.8594H3.82597C3.35401 12.8594 2.91592 13.1045 2.66904 13.5068L1.00277 16.2217C0.735405 16.6573 0.735405 17.2062 1.00277 17.6418L2.66904 20.3567C2.91592 20.759 3.35401 21.0041 3.82597 21.0041H13.0155V26.4336H8.95107C8.20136 26.4336 7.59361 27.0413 7.59361 27.791C7.59361 28.5407 8.20136 29.1485 8.95107 29.1485H19.8107C20.5604 29.1485 21.1681 28.5407 21.1681 27.791C21.1681 27.0413 20.5604 26.4336 19.8107 26.4336H15.7304V19.7496C15.7329 19.7156 15.7342 19.6813 15.7342 19.6466V14.2168C15.7342 14.1822 15.7329 14.1479 15.7304 14.1139V11.5021H24.9237C25.3957 11.5021 25.8338 11.257 26.0807 10.8548L27.747 8.13985C28.0143 7.70422 28.0143 7.15534 27.747 6.71972L26.0807 4.00481C25.8338 3.60256 25.3957 3.35742 24.9237 3.35742H15.7304V2.00003Z",
    fill: "url(#paint0_linear_2002_1328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_1328",
    x1: 0.169121,
    y1: 0.642595,
    x2: 30.0314,
    y2: 1.34934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0279144,
    stopColor: "#A451D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948784,
    stopColor: "#603DB1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionalGuidance);
export default __webpack_public_path__ + "static/media/nutritional-guidance.edfccef375b9f22b052bd879aeef2f55.svg";
export { ForwardRef as ReactComponent };